'use client';
import React from 'react';
import { StoryObject } from '@benzinga/advanced-news-manager';
import { formatImageUrl } from '@benzinga/utils';
import { getSponsoredContentLabel } from '@benzinga/article-manager/sponsored-utils';
import { PostCard, PostCardProps } from './PostCard';
import classNames from 'classnames';
import Hooks from '@benzinga/hooks';
import { isPaywallArticle, isProOnlyPost } from '@benzinga/article-manager';

const nodeUrl = node => {
  return node.url;
};

export const DefaultNewsElement: React.FC<{
  node: StoryObject & { isHighlighted?: boolean };
  postCardProps?: PostCardProps;
}> = ({ node, postCardProps = {} }) => {
  const [didImpress, setDidImpress] = React.useState<boolean>(false);
  const [isHighlighted, setIsHighlighted] = React.useState<boolean>(node?.isHighlighted ?? false);

  const ref = React.useRef<HTMLDivElement | null>(null);
  const entry = Hooks.useIntersectionObserver(ref as React.RefObject<Element>, {});
  const isVisible = !!entry?.isIntersecting;

  const sponsoredData = getSponsoredContentLabel(node);
  const url = nodeUrl(node);

  const hasEdgeBadge = node ? isPaywallArticle(node) : false;

  React.useEffect(() => {
    if (isVisible && !didImpress) {
      setDidImpress(true);
    } else if (!isVisible && didImpress) {
      setIsHighlighted(false);
      node.isHighlighted = false;
    }
  }, [didImpress, isVisible, node]);

  return (
    <div className={classNames('newsfeed-card text-black', { fade: isVisible, highlight: isHighlighted })} ref={ref}>
      <PostCard
        created={node.created}
        dateType="med"
        description={node.teaser ?? ''}
        hasEdgeBadge={hasEdgeBadge}
        hideEmptyThumb={false}
        id={node.id}
        image={formatImageUrl(node)}
        isOnlyProPost={isProOnlyPost(node)}
        layout="feed"
        size="nano"
        sponsored={sponsoredData.isSponsored}
        sponsoredLabel={sponsoredData?.label}
        stocks={node.stocks}
        title={node.title}
        url={url}
        {...(postCardProps ?? {})}
        showCommentsIcon={sponsoredData.isSponsored ? false : postCardProps.showCommentsIcon}
      />
    </div>
  );
};

export default DefaultNewsElement;
